var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#111F3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,5.7H8.8L7.4,4.1L7.3,3.9H1.8C1,3.9,0.4,4.7,0.4,5.4v9.7c0,0.9,0.6,1.5,1.5,1.5h13.5 c0.9,0,1.5-0.6,1.5-1.5v-8C16.9,6.3,16.2,5.7,15.3,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,3.7h-6.7L9.4,2.1L9.2,2H3.8C3,2,2.4,2.6,2.3,3.3h4.9c0.2,0,0.5,0.1,0.6,0.4L8.9,5h6.3 c1.2,0,2.2,1,2.2,2.2v7.5c0.7-0.1,1.3-0.7,1.3-1.5V5.2C18.9,4.3,18.1,3.7,17.4,3.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.325dfc79f53eb0cd103be40ca39981e6.svg";
export { ForwardRef as ReactComponent };